import { Recipient } from "../models/recipients";
import { UsersRepo } from "../../users/users.repo";
import { EmailRepo } from "../email.repo";
import * as _ from 'lodash';

class CreateEmailController implements angular.IOnInit, angular.IOnDestroy {
  public searchText = "";
  public emailTemplate = ""
  public emailSubject = ""
  public files: FileList;
  public recipients: Recipient[] = []

  public availableRecipients: Recipient[] = [];

  private attachmentsControl: HTMLInputElement;

  /** @ngInject */
  constructor(private $scope: angular.IScope, private $state: angular.ui.IStateService, private $mdDialog: angular.material.IDialogService,
    private usersRepo: UsersRepo, private emailRepo: EmailRepo) { }

  $onInit(): void {
    this.usersRepo.getUserEmailGroups()
      .then(groups => {
        const recipientIndividuals = _.uniqBy(groups.reduce((prev, curr) => [...prev, ...curr.items], [])
          .map(i => (<Recipient>{
            name: i.name,
            type: 'Individual',
            addresses: [{
              userId: i.id,
              address: i.email,
              selected: true
            }]
          })), (i) => i.name )

        const recipientGroups = groups.map(g => (<Recipient>{
          name: g.groupName,
          type: 'Group',
          addresses: g.items.map(i => ({ userId: i.id, address: i.email, selected: true }))
        }))

        this.availableRecipients = [...recipientGroups, ...recipientIndividuals];
      })

    // Consider getting this element through a directive ¯\_(ツ)_/¯
    this.attachmentsControl = document.getElementById('attachments') as HTMLInputElement;
    this.attachmentsControl.addEventListener('change', this.onFilesSelected.bind(this));
  }

  private onFilesSelected(event) {
    this.files = event.target.files;
    this.$scope.$apply();
  }

  $onDestroy(): void {
    this.attachmentsControl.removeEventListener('change', this.onFilesSelected.bind(this));
  }

  public selectedAddress(recipientGroup: Recipient) {
    return recipientGroup.addresses.filter(a => a.selected).length;
  }

  public filterRecipientOptions(filterText: string) {
    const query = filterText.toLowerCase();
    return this.availableRecipients.filter(a => a.name.toLowerCase().includes(query));
  }

  public showGroupRecipients(recipientGroup: Recipient) {
    const dialogScope = this.$scope.$new() as any;
    dialogScope.groupAddresses = recipientGroup.addresses;

    this.$mdDialog.show({
      scope: dialogScope,
      template: '<address-list-dialog addresses="groupAddresses"></address-list-dialog>'
    })

  }

  public sendEmail() {
    const formData = new FormData();
    formData.append('message', this.emailTemplate)
    formData.append('subject', this.emailSubject)

    Array.from(this.attachmentsControl.files).forEach(file => formData.append('attachments', file))

    this.recipients.map(recipient => {
      return _.uniq(recipient.addresses.filter(address => address.selected))
    }).forEach(group => {
      group.forEach(user => {
        formData.append('userids', user.userId.toString())
      })
    });


    this.emailRepo.sendGroupEmail(formData)
      .then(() => this.$state.go('^'));
  }

  public cancelEmail() {
    this.$state.go('^');
  }

  public getChipTitle = ($chip) => {
    if($chip && $chip.type === 'Individual'){
      return $chip.addresses[0].address
    }
  }
}

export const createEmail: angular.IComponentOptions = {
  controller: CreateEmailController,
  template: require('./createEmail.html')
}



// WEBPACK FOOTER //
// ./src/app/bulkemailing/views/createEmail.ts